<template>
  <div id="accessory-container">
    <BackToTopButton />
    <ModalSearch />
    <BreadCrumbs />
  </div>
</template>


<script>
import BackToTopButton from '@/components/layout/accessory/BackToTopButton';
import ModalSearch from '@/components/layout/accessory/ModalSearch';
import BreadCrumbs from '@/components/layout/accessory/BreadCrumbs';


export default {
  name: 'AccessoryMain',
  data() {
    return {
    };
  },
  components: {
    BackToTopButton,
    ModalSearch,
    BreadCrumbs,
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/AccessoryMain.vue